








































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Navbar as BrankasNavbar, SvgIcon } from "@brankas/web-ui";
import { UserProfile } from "@/types";
import utils from "@/utils/auth-utils";

const authModule = namespace("auth");

@Component({
  name: "navbar",
  components: {
    BrankasNavbar,
    SvgIcon,
  },
})
export default class Navbar extends Vue {
  @authModule.State("user") userProfile!: UserProfile;
  @authModule.Action("resetAuthInfo") resetAuthInfo!: () => void;
  @authModule.Getter("isAuthenticated") isAuthenticated!: boolean;
  @authModule.Getter("sessionExpiredAt") sessionExpiredAt!: number;

  mounted() {
    window.setInterval(async () => {
      const isSessionExpired = utils.isTokenExpired(this.sessionExpiredAt);
      if (
        (!this.isAuthenticated || isSessionExpired) &&
        process.env.NODE_ENV !== "development"
      ) {
        await this.onLogout();
      }
    }, 5000);
  }

  get displayName(): string {
    if (!this.userProfile) return "User";
    return this.userProfile.name;
  }

  get userAvatar(): string {
    if (!this.userProfile) return "";
    return this.userProfile.imageUrl;
  }

  async onLogout(): Promise<void> {
    try {
      await this.$gAuth.signOut();
      this.resetAuthInfo();
      this.$router.push("/sign-in");
      this.$router.go(0);
    } catch (error) {
      console.log("Failed to logout: ", error);
    }
  }

  async onLogoutClick(): Promise<void> {
    this.$gAuth?.GoogleAuth?.accounts?.id?.disableAutoSelect();
    await this.onLogout();
  }

  onUserClick() {
    return;
  }
}
